
import React, { useState } from 'react';
import { TextField, Typography, Box, Grid } from '@mui/material';

const getRating = (value) => {
    value = Number(value); // force numeric
    if (value >= 96 && value <= 100) {
        return 'OUTSTANDING';
    } else if (value >= 80 && value <= 95) {
        return 'MEETS ALL EXPECTATIONS';
    } else if (value >= 61 && value <= 79) {
        return 'MEETS MOST EXPECTATIONS';
    } else {
        return 'BELOW EXPECTATION';
    }
};

const EmployeePMSRating = ({ getKraKpiAppraisalForm }) => {
    console.log(getKraKpiAppraisalForm, "getKraKpiAppraisalForm")
    const [employeeScore, setEmployeeScore] = useState('');
    const [managerScore, setManagerScore] = useState('');
    const [reviewerScore, setRecviewerScore] = useState('');


    const handleScoreChange = (value, setScore) => {
        if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
            setScore(value);
        }
    };

    return (
        <Box>
            {/* Employee Section */}
            <Grid container spacing={2}>
                <>
                    <Grid size={{ xs: 12, md: 6 }}>

                        <Typography variant="h6">Rating:</Typography>
                        <Box bgcolor="#2980b9" color="#fff" p={1.5} borderRadius={1} mb={2} sx={{
                            height: "45px",
                            fontWeight: "800",

                        }}>
                            {getKraKpiAppraisalForm?.data?.reviewer_rating}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>


                        <Typography variant="h6">PMS Score:</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            disabled
                            value={getKraKpiAppraisalForm?.data?.reviewer_pms_score}

                            // onChange={(e) => handleScoreChange(e.target.value, setEmployeeScore)}
                            inputProps={{ min: 0, max: 100 }}
                            // sx={{ backgroundColor: '#2980b9', input: { color: '#fff' } }}
                            sx={{
                                backgroundColor: '#2980b9', color: 'white', height: "45px",
                                borderRadius: "5px",


                                '& .MuiOutlinedInput-input': {
                                    color: 'white',
                                    padding: '12.5px',
                                    border: "none",
                                    borderRadius: "10px",
                                    fontWeight: "800",

                                    '&.Mui-disabled': {
                                        opacity: 1, // ensures full visibility
                                        WebkitTextFillColor: 'white', // override default gray
                                    }
                                },
                            }}
                        />
                    </Grid>



                </>

            </Grid >

        </Box >
    );
};

export default EmployeePMSRating;
